export default __webpack_public_path__ + "3dac79c25b0447d6deba6bb7f70c1a85.png";